export const GET_CLUB_BILLING_STATUS = `
  query GetClubBillingStatus($clubId: String!) {
    getClubBillingStatus(clubId: $clubId) {
      clubId
      isPremium
      status
      currentPeriodEnd
      trialEnd
      cancelAtPeriodEnd
      customerId
      subscriptionId
    }
  }
`;

export const CREATE_CLUB_CHECKOUT_SESSION = `
  mutation CreateClubCheckoutSession($clubId: String!) {
    createClubCheckoutSession(clubId: $clubId) {
      url
      sessionId
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = `
  mutation CreateBillingPortalSession($clubId: String!) {
    createBillingPortalSession(clubId: $clubId) {
      url
    }
  }
`;
